import _ from 'lodash'
import React from 'react'
import { Input } from 'semantic-ui-react'
import Icon from '../icon'
import classnames from 'classnames/bind'
import styles from './styles.scss'

const cx = classnames.bind(styles)

type ButtonWidth = undefined | 'fluid'

interface SearchFilterProps {
  elmId?: string
  onSearchIconClick?: () => void
  onResetIconClick: () => void
  label?: string
  disabled?: boolean
  placeholder?: string
  onChange: (
    e: React.ChangeEvent<HTMLInputElement>,
    data: Record<string, unknown>
  ) => void
  value?: string
  inputRef?: React.RefObject<HTMLInputElement>
  width?: ButtonWidth
  compact?: boolean
}

const SearchFilter = ({
  elmId = 'search_filter',
  onSearchIconClick = () => undefined,
  onResetIconClick,
  disabled,
  placeholder = 'Search...',
  onChange,
  value = '',
  inputRef,
  width,
  compact,
}: SearchFilterProps) => {
  const isEmpty = _.isEmpty(value)

  return (
    <div
      className={cx(
        'search-filter',
        { active: !isEmpty },
        { 'fluid-width': width === 'fluid' }
      )}
    >
      <Input
        // @ts-ignore next line
        ref={inputRef}
        data-elm-id={`${elmId}_input`}
        onChange={onChange}
        value={value}
        icon={{
          name: 'search',
          link: true,
          onClick: onSearchIconClick,
        }}
        placeholder={placeholder}
        disabled={disabled}
        clearable
        iconPosition='left'
        compact={compact}
      />
      {!isEmpty && (
        <div className={cx('reset-button')} onClick={onResetIconClick}>
          <Icon color='white' iconStyle='solid' name='xmark' size='medium' />
        </div>
      )}
    </div>
  )
}

export default SearchFilter
